import { createContext, useContext } from 'react';
export const PortalPlatformDataContext = /*#__PURE__*/createContext(null);
export const usePortalPlatformData = () => {
  const context = useContext(PortalPlatformDataContext);
  if (!context) {
    throw new Error('usePortalPlatformData must be used within a PortalPlatformDataProvider');
  }
  return context;
};
export const useBrandSettings = () => {
  const portalPlatformData = usePortalPlatformData();
  return portalPlatformData.context.brandSettings;
};